var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    width: 7.381,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.278 4.8L.373.042a.238.238 0 00-.373.2v9.52a.238.238 0 00.373.2l6.9-4.762a.238.238 0 000-.392z"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_caret-right-173a722c.svg";
export { SvgIcnCaretRight as ReactComponent };